import { Fotos3x4Format } from "./fotos3x4Format";
import { NormalFormat } from "./normalFormat";
import { PassaporteFormat } from "./passaporteFormat";
import { PolaroidFormat } from "./polaroidFormat";
import { TirinhaFormat } from "./tirinhaFormat";

export function createFormat(tipo, options = {}) {
  const map = {
    normal: () => new NormalFormat(options),
    polaroid: () => new PolaroidFormat(options),
    fotos_3x4: () => new Fotos3x4Format(options),
    passaporte: () => new PassaporteFormat(options),
    tirinha: () => new TirinhaFormat(options),
    // adicione novos formatos aqui, sem tocar no editor
  };
  const factory = map[tipo];
  if (!factory) throw new Error(`Formato desconhecido: ${tipo}`);
  return factory();
}
